import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import EditTemplateModalRow from "./EditTemplateRow";
import { settingsColor, rev2, handleSendGlobal } from "../../helpers";
import {
  // runRiskCalcs,
  sortTemplates,
  addRiskTemplate,
} from "../../store/entities/global";
import add from "../../images/plusButtonPurple.png";
import { updateUserSelection } from "../../store/user";
import FilterCategory from "./FilterCategory";
import TableTabs from "../table/TableTabs";

export default function EditRiskTemplates() {
  const dispatch = useDispatch();
  const { riskData } = useSelector(
    (state) => state.entities.global.data.riskTemplates
  );

  const { selectedRiskType, selectedCategory } = useSelector(
    (state) => state.user
    );
    console.log(selectedRiskType, selectedCategory);
  let filteredTemplates = riskData.filter(
    (template) => template.riskType === selectedRiskType
  );

  if (selectedCategory)
    filteredTemplates = filteredTemplates.filter(
      (template) => template.category === selectedCategory
    );

  function handleNew() {
    dispatch(addRiskTemplate({ riskType: selectedRiskType }));
  }

  // incase its needed in the future
  // function runCalcs() {
  //   dispatch(runRiskCalcs());
  // }

  function sort() {
    dispatch(sortTemplates());
    handleSendGlobal()
  }

  const tabs = [
    "Managerial",
    "Technical",
    "Commercial",
    "Legal",
    "Environmental",
  ];
  const data = {
    tabs,
    selectedTab: selectedRiskType,
    select: (selected) => {
      dispatch(
        updateUserSelection({
          key: "selectedRiskType",
          value: selected,
        })
      );
    },
  };

  return (
    <Container>
      <div className="editWindow">
        <TableTabs data={data} />
        {/* <Close data={data} /> */}
        {rev2 ? <FilterCategory /> : null}
        <div className="titles">
          <div className="textarea title desc">
            <p>Description</p>
          </div>
          <div className="toggle title">
            <p>L</p>
          </div>
          <div className="toggle title">
            <p>S</p>
          </div>
          <div className="textarea title miti">
            <p>Mitigation</p>
          </div>
          <div className="toggle title">
            <p>L</p>
          </div>
          <div className="toggle title">
            <p>S</p>
          </div>
          <button className="cat title end">Cat</button>
        </div>
        <div className="templatesList" dir="ltr">
          {filteredTemplates.map((template, index) => {
            return (
              <EditTemplateModalRow
                key={index}
                template={template}
                selectedRiskType={selectedRiskType}
              />
            );
          })}
        </div>
        <div className="buttonRow">
          <button className="addIcon" onClick={handleNew}>
            <img src={add} alt="add" />
          </button>
          {/* <button className="sort" onClick={runCalcs}>
          run risk calcs
        </button> */}
          <button className="sort" onClick={sort}>
            Sort Templates
          </button>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  z-index: 2;
  position: relative;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  /* } */
  .titles {
    display: flex;
    /* padding: 3px; */
    margin: 3px 30px;
  }
  .title {
    border: none;
    font-weight: bold;
    margin-right: 4px;
    padding: 4px;
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
  }
  .templatesList {
    max-height: calc(100vh - 320px);
    overflow: scroll;
    scroll-snap-type: y mandatory;
  }
  .cat {
    text-align: center;
    width: 40px;
    :focus {
      border: 1px solid ${settingsColor};
    }
  }
  .end {
    margin-right: 0;
  }
  .desc {
    flex-basis: 0;
    flex-grow: 1;
  }
  .miti {
    flex-basis: 0;
    flex-grow: 2;
  }
  .toggle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 55px;
    font-size: 12px;
  }
  .addIcon {
    max-width: 25px;
    max-height: 25px;
    padding: 0;
    border: none;
  }
  .buttonRow {
    margin: 5px 30px;
    display: flex;
    align-items: center;
    /* border: 1px solid red; */
    .sort {
      margin-left: 10px;
      border: none;
      background-color: ${settingsColor};
      color: white;
      font-weight: bold;
      padding: 5px 10px;
    }
  }
`;
